<template>
  <div class="trend-chart">
    <a-row>
      <a-col :lg="24" :xl="24" :xxl="12">
        <v-chart :options="pieOptions" />
      </a-col>
      <a-col :lg="24" :xl="24" :xxl="12">
        <v-chart :options="barOptions" />
      </a-col>
    </a-row>
  </div>
</template>

<script>
import ECharts from 'vue-echarts'
import 'echarts/lib/chart/bar'
import 'echarts/lib/component/tooltip'
import 'echarts/lib/component/legend'
import 'echarts/lib/component/title'
import 'echarts/lib/chart/pie'
import { formatAmount } from '@/utils/util'

export default {
  data() {
    return {
      KEY_NAME_OBJ: {
        assuranceAmount: '担保额度',
        insuranceAmount: '保险额度',
        limitAmount: '总信用限额',
        validAmount: '当前有效额度',
      },
    }
  },
  props: ['dataSource'],

  computed: {
    pieOptions() {
      const dataSource = this.dataSource
      const options = {
        color: [
          '#57b13a',
          '#50CBCC',
          '#479FFF',
          '#FBD44A',
          '#F4667B',
          '#9760E5',
        ],
        title: {
          left: 'center',
        },
        tooltip: {
          trigger: 'item',
          // formatter: '{a} <br/>{b} : {c} ({d}%)'
          formatter: function(params) {
            const amount = formatAmount(params.value)
            const str = `${params.name}: ${amount} (${params.percent}%)`
            return str
          },
        },
        legend: {
          top: 50,
          itemGap: 20,
          data: [
            '尚未逾期',
            '逾期1-30D',
            '逾期31-60D',
            '逾期61-90D',
            '逾期91-180D',
            '逾期大于180D',
          ],
        },
        series: [
          {
            name: '金额',
            type: 'pie',
            radius: '55%',
            center: ['50%', '60%'],
            data: [
              { value: dataSource.notOverdue, name: '尚未逾期' },
              { value: dataSource.overdueOne, name: '逾期1-30D' },
              { value: dataSource.overdueThirty, name: '逾期31-60D' },
              { value: dataSource.overdueSixty, name: '逾期61-90D' },
              { value: dataSource.overdueNinety, name: '逾期91-180D' },
              { value: dataSource.overdueHundredEighty, name: '逾期大于180D' },
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)',
              },
            },
          },
        ],
      }
      return options
    },
    barOptions() {
      const dataSource = this.dataSource
      const options = {
        color: ['#4DB8EF', '#F7D15C'],
        title: {
          left: 'center',
          subtext: 'TOTAL AR = NET AR + 未清来款',
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            // 坐标轴指示器，坐标轴触发有效
            type: 'shadow', // 默认为直线，可选为：'line' | 'shadow'
          },
          // formatter: '{b0}({c0}) = {a1}({c1}) + {a2}({c2})',
          formatter: function(params) {
            const str = params.reduce((prev, crt, index) => {
              let op = ''
              switch (index) {
                case 0:
                  op = '='
                  break
                case 1:
                  op = '+'
                  break
                default:
                  break
              }
              prev += `${crt.seriesName}(${formatAmount(crt.value)})${op}`
              return prev
            }, '')
            return str
          },
        },
        legend: {
          top: 60,
          data: ['NET AR', '未清来款'],
        },
        grid: {
          top: 100,
          containLabel: true,
        },
        xAxis: {
          type: 'value',
          // show: false,
          splitLine: {
            lineStyle: {
              type: 'dotted',
            },
          },
          axisTick: {
            show: false,
          },
          axisLine: {
            show: false,
          },
        },
        yAxis: {
          type: 'category',
          data: ['Total AR'],
          axisTick: {
            show: false,
          },
        },
        series: [
          {
            // 显示总数
            name: 'Total AR',
            type: 'bar',
            barGap: '-100%', // 左移100%，stack不再与上面两个在一列
            label: {
              normal: {
                show: true,
                position: 'right',
                textStyle: { color: '#000' },
              },
            },
            itemStyle: {
              normal: {
                color: 'rgba(128, 128, 128, 0.3)', // 仍为透明
              },
            },
            data: [dataSource.totalAr],
            barWidth: 80,
          },
          {
            name: 'NET AR',
            type: 'bar',
            stack: '总量',
            label: {
              show: true,
              position: 'insideTopRight',
            },
            data: [dataSource.netAr],
            barWidth: 80,
          },
          {
            name: '未清来款',
            type: 'bar',
            stack: '总量',
            label: {
              show: true,
              position: 'insideBottomRight',
            },
            data: [dataSource.amountReceipt],
          },
        ],
      }
      return options
    },
  },
  components: {
    'v-chart': ECharts,
  },
}
</script>

<style lang="less" scoped>
.trend-chart {
  .echarts {
    display: inline-block;
    vertical-align: middle;
    width: 800px;
    height: 500px;
  }
}
</style>
